import { Navigate } from 'react-router-dom';
import { useAbility, type Action, type Subject } from '../lib/abilities';

/**
 * Generic route guard — sayfaya girmek için ability gerektirir.
 *
 * Yetki yoksa `redirectTo` adresine yönlendirir (default `/`).
 * Defense in depth: backend AbilitiesGuard zaten 403 dönüyor — bu component
 * frontend tarafında "kırık UI + console 403 spam" yerine net redirect sağlar.
 *
 * Kullanım:
 *   <Route path="/raporlar" element={
 *     <RequireAbility action="read" subject="Report">
 *       <ReportsPage />
 *     </RequireAbility>
 *   } />
 */
export function RequireAbility({
  action,
  subject,
  redirectTo = '/',
  children,
}: {
  action: Action;
  subject: Subject;
  redirectTo?: string;
  children: React.ReactNode;
}) {
  const ability = useAbility();
  if (!ability.can(action, subject)) {
    return <Navigate to={redirectTo} replace />;
  }
  return <>{children}</>;
}
